import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { RequestMultiSelect } from '../../../RequestMultiSelect'
import { RequestSelectFormikField } from '../../../RequestSelectFormikField'
import { REQUEST_FORM_FIELD_NAME_RELATED_REQUESTS } from '../../RequestForm.constants'

import { API_PARAMS } from './RelatedRequestsField.constants'

import * as styles from './RelatedRequestsField.module.css'

function RelatedRequestsField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <RequestSelectFormikField
      multi
      Select={RequestMultiSelect}
      apiParams={API_PARAMS}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Request.RelatedRequestPlaceholderKey'),
          },
        },
      }}
      fieldComponentProps={{
        label: `${t('Request.RelatedRequestLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      name={REQUEST_FORM_FIELD_NAME_RELATED_REQUESTS}
      tagsProps={{
        className: styles.relatedRequestsFieldTags,
      }}
    />
  )
}

export default RelatedRequestsField
